import React, { useState } from 'react';
import '../MortgageCalculator.css';

const PaymentEstimator: React.FC = () => {
  const [loanAmount, setLoanAmount] = useState<string>('300000');
  const [interestRate, setInterestRate] = useState<string>('5.5');
  const [loanTerm, setLoanTerm] = useState<string>('30');
  const [monthlyPayment, setMonthlyPayment] = useState<number | null>(null);

  const calculatePayment = () => {
    const principal = parseFloat(loanAmount);
    const monthlyRate = parseFloat(interestRate) / 100 / 12;
    const termMonths = parseInt(loanTerm) * 12;
    
    if (principal > 0 && monthlyRate > 0 && termMonths > 0) {
      const payment = 
        (principal * monthlyRate * Math.pow(1 + monthlyRate, termMonths)) / 
        (Math.pow(1 + monthlyRate, termMonths) - 1);
      
      setMonthlyPayment(payment);
    } else {
      setMonthlyPayment(null);
    }
  };

  return (
    <div className="calculator">
      <h2>Mortgage Payment Estimator</h2>
      
      <div className="input-group">
        <label htmlFor="loanAmount">Loan Amount ($)</label>
        <input
          id="loanAmount"
          type="number"
          value={loanAmount}
          onChange={(e) => setLoanAmount(e.target.value)}
        />
      </div>
      
      <div className="input-group">
        <label htmlFor="interestRate">Interest Rate (%)</label>
        <input
          id="interestRate"
          type="number"
          step="0.01"
          value={interestRate}
          onChange={(e) => setInterestRate(e.target.value)}
        />
      </div>
      
      <div className="input-group">
        <label htmlFor="loanTerm">Loan Term (years)</label>
        <input
          id="loanTerm"
          type="number"
          value={loanTerm}
          onChange={(e) => setLoanTerm(e.target.value)}
        />
      </div>
      
      <button onClick={calculatePayment}>Calculate Payment</button>
      
      {monthlyPayment !== null && (
        <div className="result">
          <h3>Monthly Payment</h3>
          <p>${monthlyPayment.toFixed(2)}</p>
        </div>
      )}
    </div>
  );
};

export default PaymentEstimator;